import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPeopleRoof } from '@fortawesome/free-solid-svg-icons/faPeopleRoof';
import type { IconProps } from '../../types';

export function PeopleRoofIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'People Under Roof',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faPeopleRoof}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
